import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicesSharedService {

  private sumSubject = new BehaviorSubject<number>(0);
  public sum$ = this.sumSubject.asObservable();

  constructor() {}

  calculateSum(a: number, b: number): void {

    const result = Number(a) + Number(b);
    
    this.sumSubject.next(result);
  }

  getCurrentSum(): number {
    return this.sumSubject.value;
  }
}
